"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectItem = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_radio_buttons_1 = require("@hopin-team/ui-radio-buttons");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var label_1 = require("../styled/label");

var media_1 = require("../styled/media");

var select_items_styled_1 = require("../styled/select-items.styled");

var utils_1 = require("../utils");

var SelectItemLabel = function SelectItemLabel(_a) {
  var subtitle = _a.subtitle,
      isSingle = _a.isSingle,
      hasHalon = _a.hasHalon,
      label = _a.label,
      isInverse = _a.isInverse,
      makeClasses = _a.makeClasses;
  return react_1.default.createElement(ui_flex_1.Flex, {
    flexDirection: subtitle ? 'column' : 'row',
    pl: hasHalon && isSingle ? 1.5 : 0
  }, label, subtitle && react_1.default.createElement(label_1.Subtitle, {
    className: makeClasses('Subtitle'),
    color: isInverse ? 'grey-400' : 'grey-medium',
    pattern: "caption"
  }, subtitle));
};

var SelectItem = function SelectItem(props) {
  var contextValue = (0, react_1.useContext)(context_1.SelectItemsContext);
  var radioContextValue = (0, react_1.useContext)(ui_radio_buttons_1.RadioButtonsContext);

  var _a = contextValue !== null && contextValue !== void 0 ? contextValue : {},
      isSingle = _a.isSingle,
      isInverse = _a.isInverse,
      hasErrors = _a.hasErrors,
      isDisabled = _a.isDisabled;

  var _b = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: isSingle ? 'RadioButton' : 'Checkbox',
    className: props.className,
    __UIScope: props.__UIScope
  }),
      makeClasses = _b.makeClasses,
      rootClasses = _b.rootClasses;

  if (!contextValue) {
    return null;
  }

  var withSubtitle = Boolean(props.subtitle);

  var label = props.label,
      subtitle = props.subtitle,
      media = props.media,
      selectItemProps = tslib_1.__rest(props, ["label", "subtitle", "media"]);

  var hasBadge = media && (0, utils_1.isMediaBadge)(media);
  var hasHalon = media && (0, utils_1.isMediaHalon)(media);
  var clonedMedia = cloneMedia(media, hasBadge);

  if (isSingle) {
    var selected = !!(radioContextValue && radioContextValue.selectedValue === props.value);
    return react_1.default.createElement(select_items_styled_1.StyledRadioButton, tslib_1.__assign({
      className: rootClasses,
      withSubtitle: withSubtitle,
      hasErrors: hasErrors,
      isDisabled: isDisabled,
      isInverse: isInverse,
      hasMedia: !!clonedMedia,
      hasHalon: hasHalon
    }, selectItemProps, {
      selected: selected
    }), react_1.default.createElement(media_1.MediaWrapper, {
      hasBadge: hasBadge,
      hasHalon: hasHalon,
      isSingle: true
    }, hasHalon && react_1.default.createElement("div", null, clonedMedia), react_1.default.createElement(SelectItemLabel, {
      makeClasses: makeClasses,
      label: label,
      subtitle: subtitle,
      hasHalon: hasHalon,
      isInverse: isInverse,
      isSingle: isSingle
    }), hasBadge && react_1.default.createElement("div", null, clonedMedia)));
  }

  return react_1.default.createElement(select_items_styled_1.StyledCheckbox, tslib_1.__assign({
    withSubtitle: withSubtitle,
    hasErrors: hasErrors,
    isDisabled: isDisabled,
    isInverse: isInverse,
    hasMedia: !!clonedMedia
  }, selectItemProps), react_1.default.createElement(media_1.MediaWrapper, {
    hasBadge: hasBadge,
    hasHalon: hasHalon,
    isSingle: false
  }, react_1.default.createElement(SelectItemLabel, {
    makeClasses: makeClasses,
    label: label,
    subtitle: subtitle,
    hasHalon: hasHalon,
    isInverse: isInverse,
    isSingle: isSingle
  }), react_1.default.createElement("div", null, clonedMedia)));
};

var cloneMedia = function cloneMedia(media, hasBadge) {
  var mediaProps = hasBadge ? {
    priority: 'low',
    pattern: 'informational'
  } : {
    scale: 4
  };

  if ((0, react_1.isValidElement)(media)) {
    return (0, react_1.cloneElement)(media, mediaProps);
  } else return null;
};

SelectItem.displayName = 'SelectItem';
var SelectItemWithSpace = (0, ui_helper_with_space_1.withSpace)(SelectItem);
exports.SelectItem = SelectItemWithSpace;